export const not = (predicate) => {
  return (traffic) => {
    return !predicate(traffic);
  };
};
